import DropdownList from './DropdownList'
import Dropdown from './index'

const DropdownControl = (props) => {
  const { isGrouped, type, align, trigger, items, displayListUpwards } = props

  return (
    <Dropdown
      class={'control-dropdown'}
      trigger={trigger}
    >
      <DropdownList
        displayListUpwards={displayListUpwards}
        isGrouped={isGrouped}
        type={type}
        align={align}
        items={items}
      />
    </Dropdown>
  )
}

export default DropdownControl
